exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loading-module__loadingWrapper___n5kMo {\n  padding: 30px 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);

// exports
exports.locals = {
	"loadingWrapper": "Loading-module__loadingWrapper___n5kMo"
};